import { v4 as uuidv4 } from 'uuid';

// this is an approximation of immutable.js Record

export type DeepPartial<T> = {
  [K in keyof T]?: T[K] extends object ? DeepPartial<T[K]> : T[K];
};

export const createRecord =
  <T>(defaultKeys: T) =>
  (values: DeepPartial<T> = {}): T => {
    return Object.keys(defaultKeys).reduce((acc, key) => {
      if (values?.hasOwnProperty(key)) {
        acc[key] = values[key];
      } else {
        acc[key] = defaultKeys[key];
      }

      return acc;
    }, {} as T);
  };

export const withDefaults =
  <T>(defaultKeys: T) =>
  (values: Partial<T> | DeepPartial<T> = {}): T => {
    return Object.keys(defaultKeys).reduce((acc, key) => {
      if (values?.hasOwnProperty(key)) {
        acc[key] = values[key];
      } else {
        if (key === 'id') {
          acc[key] = uuidv4();
        } else {
          acc[key] = defaultKeys[key];
        }
      }

      return acc;
    }, {} as T);
  };
